// startup
// Load entry module and return exports
// This entry module depends on other loaded chunks and execution need to be delayed
var __webpack_exports__ = __webpack_require__.O(undefined, ["vendors-node_modules_jquery_dist_jquery_js-node_modules_virtual-fontawesome-auto_js"], () => (__webpack_require__("./src/index.js")))
__webpack_exports__ = __webpack_require__.O(__webpack_exports__);
